import { createContext, useRef, useState } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { ConfigProvider, Spin, Typography } from 'antd';
import './App.css';
import AA from './Components/AA';
import Dashboard from './Components/Dashboard';
import LandingPage from './Components/Landing';
import { initiateJourney } from './Services/PFMClient/ConsentService';
import './Theme/default.css';
import { ROUTES } from './Utils/routes';
import { setAccessToken, setUserId } from './Utils/storageUtils';

export const AppContext = createContext({});
export type ContextType = {
  phoneNumber: string;
  fipIds: string[];
  isLoading: boolean;
};

const App: React.FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const trackingId = urlParams.get('trackingId');
  const [currentRoute, setCurrentRoute] = useState<any>(ROUTES.LANDING);
  const urlPathVariales = window.location.pathname;
  const [isError, setIsError] = useState(false);
  const [currentContext, setCurrentContext] = useState({
    phoneNumber: '',
    fipIds: [],
    isLoading: false,
    isAAJourneyDone: false,
  });
  const [loading, setIsLoading] = useState(false);
  const [currentSelectedCard, setCurrentSelectedCard] = useState(0);
  const [showsideBar, setShowSideBar] = useState(false);
  const errorCreateConsent = () => {
    setIsError(true);
    setCurrentRoute(ROUTES.LANDING);
    setIsLoading(false);
  };
  const isLoanJourneyDone = useRef(false);

  const documentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty(
      '--doc-height',
      `${
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
      }px`
    );
  };

  window.addEventListener('resize', () => documentHeight());
  documentHeight();

  const renderCurrentRoute = () => {
    switch (currentRoute) {
      case ROUTES.AAJOURNEY:
        return <AA isError={errorCreateConsent} />;
      case ROUTES.DASHBOARD:
        return <Dashboard />;
      case ROUTES.LANDING:
        return (
          <LandingPage
            setIsError={setIsError}
            setShowSideBar={setShowSideBar}
            isError={isError}
            onClick={async (selectedCard: number, type: string) => {
              if (selectedCard === 1 && type !== 'profile_1_new') {
                setCurrentRoute(ROUTES.DASHBOARD);
                return;
              }
              setCurrentSelectedCard(selectedCard);
              try {
                const refreshToken: any = await initiateJourney();
                const metaData = JSON.parse(atob(refreshToken?.meta));
                setAccessToken(metaData.accessToken);
                setUserId(metaData.userId);
                setIsLoading(true);
                setCurrentRoute(ROUTES.AAJOURNEY);
              } catch (e) {
                setIsError(true);
                return;
              }
            }}
          />
        );
    }
  };

  const navigateToAA = () => {
    setCurrentRoute(ROUTES.AAJOURNEY);
  };

  const navigateToDashboard = () => {
    if (currentSelectedCard === 0) {
      setCurrentRoute(ROUTES.LANDING);
    } else {
      setCurrentRoute(ROUTES.DASHBOARD);
    }
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          paddingLG: 16,
          colorPrimary: '#0460ff',
          fontFamily: 'Poppins',
          borderRadiusLG: 20,
        },
      }}
    >
      <AppContext.Provider
        value={{
          navigateToAA,
          navigateToDashboard,
          loading,
          setIsLoading,
          isLoanJourneyDone,
          setCurrentSelectedCard,
        }}
      >
        {loading ? (
          <Spin
            className={`loader`}
            style={{
              position: 'fixed',
              inset: 0,
              width: '12rem',
              height: '5rem',
              maxWidth: '100vw',
              maxHeight: '100dvh',
              margin: 'auto',
            }}
            indicator={<LoadingOutlined spin />}
          />
        ) : (
          <></>
        )}

        <div
          className={`${
            currentRoute === ROUTES.DASHBOARD ? 'heightPercent' : 'heightVH'
          } App`}
        >
          {showsideBar ? (
            <div
              className={`imageSection ${
                currentRoute === ROUTES.AAJOURNEY ? 'configCss' : ''
              } ${
                currentRoute === ROUTES.DASHBOARD ? 'configCssDashboard' : ''
              }`}
              style={{
                background: 'linear-gradient(#62cff4,#2c67f2)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                //   width: '100%',
              }}
            >
              <img className='cssLogo' src={'/images/goodBank.png'} />{' '}
              <Typography.Text
                className='pocIcon'
                style={{ color: 'white', fontWeight: 600 }}
              >
                POC
              </Typography.Text>
            </div>
          ) : (
            <></>
          )}
          {renderCurrentRoute()}
        </div>
      </AppContext.Provider>
    </ConfigProvider>
  );
};

export default App;
